import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const SectionHeader = ({ eyebrow, title, intro, align = "left" }) => {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  const reduce = useReducedMotion();
  const rise = (delay) => ({
    initial: reduce ? { opacity: 0 } : { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-70px" },
    transition: { duration: 0.75, delay, ease: EASE },
  });

  return (
    <div className={`max-w-3xl ${alignment}`}>
      {eyebrow && (
        <motion.div
          {...rise(0)}
          className="text-xs font-semibold tracking-[0.24em] uppercase text-brand-olive"
        >
          {eyebrow}
        </motion.div>
      )}
      <motion.h2
        {...rise(0.08)}
        className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl text-brand-deep font-light leading-[1.1]"
      >
        {title}
      </motion.h2>
      {intro && (
        <motion.p
          {...rise(0.16)}
          className="mt-6 text-brand-muted text-base sm:text-lg leading-relaxed font-light"
        >
          {intro}
        </motion.p>
      )}
    </div>
  );
};

export default SectionHeader;
